export const EXPATRIATIONS_ROUTE_PATHS = {
  expatriations: '/finance/expatriations',
};

export const EXPATRIATIONS_API_PATHS = {
  accounts: '/v1/api/platform/finance-panel/accounts/all/lite',
  expatriationTypes: '/v1/api/platform/finance-panel/expatriation/types',
  brokers: '/v1/api/platform/finance-panel/brokers',
  currencies: '/v1/api/platform/common-services/all/currencies',
  calculate: '/v1/api/platform/finance-panel/expatriation/calculate',
  generate: '/v1/api/platform/finance-panel/expatriation/generate',
  mostRecent: '/v1/api/platform/finance-panel/expatriation/most-recent',
  deleteById: (id: number) => `/v1/api/platform/finance-panel/expatriation/${id}`,
};
